export default {
  validationEmpty: "Bitte geben Sie einen gültigen Wert ein.",
  validationIdentifier: "Bitte geben Sie eine Bezeichnung ein.",
  validationInvalid: "Bitte wählen Sie einen validen Wert aus.",

  validationName: "Bitte geben Sie einen Namen ein.",
  validationEmail: "Geben Sie bitte eine gültige E-Mail-Adresse ein.",
  validationUsername: "Bitte geben Sie einen gültigen Username ein.",
  validationPassword: "Bitte geben Sie ein gültiges Passwort ein.",
  validationPasswordsNotMatching:
    "Die eingegebenen Passwörter stimmen nicht überein.",
  validationCompanyEmail:
    "Bitte geben Sie eine gültige Unternehmer-E-Mail-Adresse ein.",
  validationCompanyPassword:
    "Bitte geben Sie eine gültiges Unternehmer-Passwort ein.",
  validationZipCode: "Bitte geben Sie eine gültige Postleitzahl ein.",
  validationTaxNumber:
    "Bitte geben Sie eine gültige UID- oder Steuer-Identifikationsnummer ein.",
  validationTaxIdATrustPresent:
    "Sie können dieses Feld nicht bearbeiten, solange ein A-Trust-Account zugeordnet ist.",
  validationPhoneNumber: "Bitte geben Sie eine gültige Telefonnummer ein.",
  validationTosNotAccepted:
    "Bitte lesen Sie die Geschäftsbedingungen und stimmen Sie diesen zu.",

  validationOperatorCode: "Bitte geben Sie einen gültigen Bediener-Code ein.",
  validationOperatorCodeSpecific:
    "Bitte geben Sie einen Bediener-Code mit einem Maximum von 8 Stellen ein.",
  validationOperatorPassword:
    "Bitte geben Sie eine gültiges Bediener-Passwort ein.",

  validationIBAN: "Geben Sie bitte einen gültigen IBAN ein.",
  validationBIC: "Geben Sie bitte einen gültigen BIC ein.",

  validationDateRange: "Bitte einen gültigen Zeitraum eingeben.",
  validationDate: "Bitte ein gültiges Datum eingeben.",
  validationPriceRange: "Bitte geben Sie eine gültige Preisspanne ein.",

  validationMainGroupMissing:
    "Bitte wählen Sie eine Hauptgruppe aus der Liste aus.",
  validationArticleGroupMissing:
    "Bitte wählen Sie eine Warengruppe aus der Liste aus.",
  validationArticleNumber:
    "Bitte geben Sie eine ganzzahlige Artikelnummer ein.",
  validationArticlePrice:
    "Bitte geben Sie einen gültigen Preis ein (in folgendem Format xx,yy).",
  validationPositiveAmount: "Bitte geben Sie einen positiven Betrag ein.",
  validationNoArticleGroupsAvailable:
    "Es sind keine Warengruppen für die gewählte Hauptgruppe vorhanden.",
  validationDiscount: "Rabatte dürfen nur zwischen 0 und 100 Prozent liegen.",
  validationMaxDiscount:
    "Der eingegebene Rabatt übersteigt Ihren festgelegten Maximalrabatt.",
  validationBarcodeNumber:
    "Bitte geben Sie einen gültigen Barcode ein (4 bis 48 Ziffern).",

  validationPrinterSelection: "Bitte wählen Sie einen Drucker aus.",
  validationDisplayName: "Bitte geben Sie einen gültigen Anzeigenamen ein.",
  validationInvalidLineWidth:
    "Der eingegebene Text überschreitet die optimale Länge.",

  validationModulePrice: "Modulpreise dürfen keinen negativen Wert annehmen.",
  validationColor: "Bitte wählen Sie eine valide Farbe aus.",
  validationInteraction:
    "Eine nicht unterbrechbare Aktion wird gerade ausgeführt. Bitte haben Sie einen Moment Geduld.",
  validationMutationInPastOrFuture:
    "Es können keine Operationen durchgeführt werden, welche sich in der {{type}} befinden. " +
    "Bitte überprüfen Sie die Systemzeit Ihres Gerätes.",
  validationMutationInPastDeadlock:
    "Sollten Sie zuvor Offline-Operationen in der Zukunft vorgenommen haben, " +
    "können Sie unter diesen Umständen keine weiteren Operationen durchführen, " +
    "welche unter der Zeitmarke {{timestamp}}' einzuordnen wären.\n" +
    "Bitte überprüfen Sie Ihre Internetverbindung und " +
    "warten Sie die Dauer der Verarbeitung der Offline-Operationen ab.",
} as const
